import { Button, Form, SidebarModal } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import usePortal, { usePortalForm } from '@hooks/usePortal'

import type { ActionResult } from '@redux/modules/types'

import type { PortalModel } from '@models/types'

interface ModalCallbacks {
  closeModal: () => void,
  createPortal: (payload: HandleCallbackActionParams) => Promise<ActionResult<PortalModel>>,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  modalKey?: string,
  showModal: boolean,
}

const CreatePortalModal = (props: ModalProps) => {
  const { callbacks, modalKey = 'CreatePortalModal', showModal } = props
  const { closeModal, createPortal } = callbacks

  const portalPayload = usePortal()
  const portalFormPayload = usePortalForm({}, { validateOn: 'change' })

  const {
    callbacks: {
      createPortal: createFn,
    },
    creating,
  } = portalPayload

  const {
    entityState,
    entityState: {
      short_code,
      title,
    },
    errors,
    handlers,
    saveEnabled,
  } = portalFormPayload

  const createPortalPayload = {
    callbacks: {
      action: createFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    shouldRedirect: true,
    toastText: 'Portal Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Portal" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="* Title" errorMessage={errors.title}>
            <input type="text" name="title" value={title} {...handlers} />
          </Form.Field>

          <Form.Field label="* Short Code" errorMessage={errors.short_code} marginTop="large">
            <input type="text" name="short_code" value={short_code} {...handlers} />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => createPortal(createPortalPayload)}
          size="large"
        >
          {saveEnabled ? 'Create Portal' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <CreatePortalModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
